import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SalesPortalDetailHeaderAddressFieldsFragmentDoc,
  SalesPortalDetailHeaderChatFieldsFragmentDoc,
} from '@/experiences/sales-portal/blocs/documents/sales-portal-detail-header-fragments.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalProspectDetailDocument = gql`
  query SalesPortalProspectDetail(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    restaurant: businesses_by_pk(uuid: $restaurantUUID) {
      address {
        ...SalesPortalDetailHeaderAddressFields
      }
      name
      restaurant_chats(
        limit: 1
        where: { supplier_uuid: { _eq: $supplierUUID } }
      ) {
        ...SalesPortalDetailHeaderChatFields
      }
      uuid
    }
  }
  ${SalesPortalDetailHeaderAddressFieldsFragmentDoc}
  ${SalesPortalDetailHeaderChatFieldsFragmentDoc}
`;
export function useSalesPortalProspectDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >(SalesPortalProspectDetailDocument, options);
}
export function useSalesPortalProspectDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >(SalesPortalProspectDetailDocument, options);
}
export type SalesPortalProspectDetailQueryHookResult = ReturnType<
  typeof useSalesPortalProspectDetailQuery
>;
export type SalesPortalProspectDetailLazyQueryHookResult = ReturnType<
  typeof useSalesPortalProspectDetailLazyQuery
>;
export type SalesPortalProspectDetailQueryResult = Apollo.QueryResult<
  Types.SalesPortalProspectDetailQuery,
  Types.SalesPortalProspectDetailQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalProspectDetailQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalProspectDetailQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >(SalesPortalProspectDetailDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalProspectDetailLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalProspectDetailLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalProspectDetailQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalProspectDetailQuery,
    Types.SalesPortalProspectDetailQueryVariables
  >(SalesPortalProspectDetailDocument, lazyOptions);
}
